import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import { grievanceEmail } from "../../config/legalEmails";

const HorizonPP = () => {
  const [setLoading] = useState(false);
  const [setResponse] = useState([]);
  const history = useHistory();
  const [licenseType, setLicenseType] = useState();

  useEffect(() => {
    history.location.pathname.indexOf("android")
      ? setLicenseType("android")
      : setLicenseType("ios");
  }, [history.location.pathname]);

  useEffect(() => {
    // getLicenseInfo();
  }, []);

  return (
    <>
      <div className="privacy-policy-jioglass">
        <h1 className="privacy-policy-jioglass-heading">
          TESSERACT HORIZONS PRIVACY POLICY
        </h1>
        <strong class="justify">
          Thank you for using Tesseract Horizons! Your privacy is important to
          us. To better protect your privacy, and to help ensure a rewarding
          experience for all users, we provide this privacy policy.{" "}
        </strong>
        <h3 role="presentation">
          <strong class="mr-l-20">1. Scope</strong>
        </h3>
        <span className="ul-text tab justify">
          Tesseract Horizons (hereinafter referred to as “App”, “we”, “our”,
          “us”) is committed to protecting and respecting your privacy.
        </span>

        <ul className="ul_style">
          <li role="presentation">1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            This policy (this “Privacy Policy”), together with the Terms of
            Service of the Portal (“Terms”) outlines the Portal’s privacy
            practices regarding the collection, use and safeguard of your
            information through the Portal and the services offered thereupon.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">1.2&nbsp;</li>
          <li className="li_style" role="presentation">
            By using the Portal or registering or signing up for the Portal and
            submission of Personal Information (defined later); or if you are a
            minor (under 18 years old), the submission of your Personal
            Information either by your parents (or your guardian) or by you with
            the permission of your parents (or guardian) to the Portal will be
            deemed as your acceptance of the terms set out in this Privacy
            Policy.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">1.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The Terms set out herein are an electronic record in terms of the
            Information Technology Act, 2000 (as amended / re-enacted) (“IT
            Act") and rules thereunder, and is published in accordance with the
            provisions of Rule 3 (1) (a) of Information Technology (Intermediary
            Guidelines and Digital Media Ethics code) Rules, 2021, which
            mandates for publishing of rules and regulations, privacy policy and
            terms of use for access or usage of Portal. This electronic record
            is generated by a computer system and does not require any physical
            or digital signatures. We request you to go through this Privacy
            Policy and the Terms available at [●] carefully before you decide to
            access the and use the Portal. You also expressly consent to our use
            and disclosure of your Personal Information (defined below) in the
            manner prescribed under this Privacy Policy and further signify your
            agreement to this Privacy Policy.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">2. Changes to the Privacy Policy</strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            We are obligated to protect your information in accordance with
            applicable laws, and regulations.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">2.2&nbsp;</li>
          <li className="li_style" role="presentation">
            This Privacy Policy is subject to modification based on changes in
            the business, legal and regulatory requirements and will be updated
            online. We will notify you whenever any change to the Privacy Policy
            are made. You are encouraged to periodically visit this page to
            review the Privacy Policy and any changes to it.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">3. Third Party Services </strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Please note that your web browser provider, mobile service provider,
            mobile operating system provider, third party applications including
            the applications pre-loaded on your smart phones/ devices powered by
            Android platform or iOS or customized Android ROM (“Device”), social
            media platforms and websites that you access, and third party
            operators may also collect, use and share information about you and
            your usage. We cannot control how these third parties collect, use,
            share or secure this information. For information about third-party
            privacy practices, please consult their respective privacy policies.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">4. Personal Information We Collect </strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            “Personal Information” is defined as information that can be used to
            identify you and may include details such as your name, age, gender,
            contact information, products and services you are interested in or
            require more information about. Insofar as sensitive personal
            information is concerned, it will carry the meaning as may be
            defined by applicable laws from time to time.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">4.2&nbsp;</li>
          <li className="li_style" role="presentation">
            The following is the manner in which we collect, use, share and
            retain Personal Information:
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Collection
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that the Portal may collect such Personal Information,
            whenever relevant, to help providing you with information and to
            complete any transaction or provide any product or services you have
            requested or authorized. You also consent to the collection of
            certain Personal Information in the course of your applying for the
            products and/or services.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1.2&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that some features of the Portal may allow you to share
            your screen with other users. The users with whom your screen has
            been shared would be able to take screenshots of your shared screen
            (“Screenshot”) without any notification to you.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1.3&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that the Portal allows the Participant (as defined in the
            Terms) to record the video or audio conferencing (“Recording”). Once
            the recording has started, you would be able to see the recording
            text on your Portal conference screen.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Usage
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal seeks such information either to (i) validate and process
            your request for the services of the Portal or information; (ii) to
            improve the quality of the Portal; (iii) to assist you to determine
            which services best meet your needs; (iv) to facilitate our internal
            business operations, including the fulfilment of any legal and
            regulatory requirements; (v) to provide you with recommendations
            about services you may be interested in, based on your use of the
            Portal; (vi) to provide you with marketing communications and
            advertising that the Portal believes may be of interest of you; or
            (vii) to facilitate your purchases.
          </li>
        </ul>

        <ul className="ul_style">
          <li>4.2.2.2&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal does not use any information pertaining to the Screenshot
            and the Recording. The Screenshot shall be available on the device
            of the user who has taken the Screenshot. The Recording shall be
            available with the Participant.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2.3&nbsp;</li>
          <li className="li_style" role="presentation">
            All communications and notifications via SMS, internet-based
            messaging applications like WhatsApp, voice call, email or any other
            mode by the Portal are:
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            upon the request and authorization of the user;
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2.3.2&nbsp;</li>
          <li className="li_style" role="presentation">
            ‘transactional’ and not an 'unsolicited commercial communication’ as
            per the guidelines of Telecom Regulation Authority of India
            (“TRAI”), and in compliance with the relevant guidelines of TRAI or
            such other authority in India and abroad.
          </li>
        </ul>

        <ul className="ul_style">
          <li>4.2.3</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Sharing
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            We may disclose your Personal Information to our affiliates,
            personnel, employees and consultants, when necessary to perform
            services on our behalf or on your behalf, to provide display
            advertising and promotional services, providing search results and
            links (including paid listings and links), processing credit card
            payments, providing customer service, improve our services and
            analytics, provide the products/services, testing or improvement of
            services, recommending various products or services etc. The
            Personal Information that is collected from you may be transferred
            to any destination within and/or outside India, to the extent
            permitted per applicable law. By submitting Personal Information on
            the Portal, you agree to this transfer.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.2&nbsp;</li>
          <li className="li_style" role="presentation">
            We may also share your Personal Information with external
            organizations or individuals if we believe that access, use,
            preservation or disclosure of the information is reasonably
            necessary to: (a) meet any applicable law, regulation, legal process
            or enforceable governmental request; (b) detect, prevent or
            otherwise address fraud, security or technical issues; (c) protect
            against harm to the rights, property or safety of our customers or
            the public, as required or permitted by law; (d) facilitate
            authentication and notification services in the Portal; (e) for the
            limited purpose of allowing or permitting such third-party service
            providers to optimize and display advertisements and notifications
            based on your past preferences, visits on the Portal and information
            that is collected by us.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The Participant with whom the Recording is shared can share the
            Recording with any third party and/or user(s). However, we shall not
            be responsible for any such disclosure made by the Participant to
            any third party and/or user(s).
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.4&nbsp;</li>
          <li className="li_style" role="presentation">
            We will not be liable for transfer of any Personal Information
            resulting from loss or distribution of data, the delineation or
            corruption of media storage, power failures, natural phenomena,
            riots, act(s) of vandalism, sabotage, terrorism or any other event
            beyond our control.
          </li>
        </ul>

        <ul className="ul_style">
          <li>4.2.4</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Retention
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The information so collected shall be retained only for a limited
            duration necessary to fulfil the purposes outlined herein unless a
            longer retention period is required or permitted by law and only for
            the purposes stated above. Once the purpose is achieved, all
            Personal Information shall be deleted in a safe and secure mode.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.4.2&nbsp;</li>
          <li className="li_style" role="presentation">
            The Screenshot shall not be stored in our servers and shall be
            stored in the device of the user who has taken the screenshot.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.4.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The Recording shall be stored on our servers till the organization
            account is active.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">5. Non-Personal Information </strong>
        </h3>
        <ul className="ul_style">
          <li>5.1&nbsp;</li>
          <li className="li_style" role="presentation">
            “Non-Personal Information” is defined as any data that does not
            personally identify you and may include unique system or hardware
            identifiers, system or application software, and peripherals.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.2&nbsp;</li>
          <li className="li_style" role="presentation">
            Any non-personal information, when clubbed with personal information
            shall be treated as personal information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The following is the manner in which we collect, use, share and
            retain non-personal information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.1</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Collection
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that the App may collect diagnostic, technical, usage
            related information, for the usage purposes described below.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.2</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Usage
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The above mentioned information is gathered periodically to provide
            and improve the App and services therein, facilitate the provision
            of software updates, product support and other services to you (if
            any) and to verify compliance with the terms of this Policy.  
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Sharing
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            To enable the Portal partners and third party developers to improve
            their software, hardware and services designed for use with the
            Portal, we may also provide any such partner or third party
            developer with a subset of diagnostic information that is relevant
            to that partner’s or developer’s software, hardware and/or services,
            as long as the diagnostic information is in a form that does not
            qualify as Personal Information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3.2&nbsp;</li>
          <li className="li_style" role="presentation">
            The Non-Personal Information may also be shared with external
            organizations or individuals for the limited purpose of allowing or
            permitting such third-party service providers to optimize and
            display advertisements and notifications based on your past
            preferences, visits on the Portal and information that is collected
            by us.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The Non- Personal Information that is collected from you may be
            transferred to any destination within and/or outside India, to the
            extent permitted per applicable law. By submitting Non-Personal
            Information on the Portal, you agree to this transfer.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3.4&nbsp;</li>
          <li className="li_style" role="presentation">
            We will not be liable for transfer of any Non-Personal Information
            resulting from loss or distribution of data, the delineation or
            corruption of media storage, power failures, natural phenomena,
            riots, act(s) of vandalism, sabotage, terrorism, or any other event
            beyond our control.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.4</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Retention
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The information so collected shall be retained only for a limited
            duration necessary to fulfil the purposes outlined herein unless a
            longer retention period is required or permitted by law and only for
            the purposes defined above. Once the purpose is achieved, all
            information is deleted in a safe and secure mode.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">6. Privacy for End Customers </strong>
        </h3>
        <ul className="ul_style">
          <li>6.1&nbsp;</li>
          <li className="li_style" role="presentation">
            When an End Customer (defined below in Clause 6.6) access, views
            and/or interacts with Customer Content (as defined in the Terms)
            created with our Services, we generally do not attempt to process
            information about who the End Customer is, but do process device and
            application information such as an IP address.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.2&nbsp;</li>
          <li className="li_style" role="presentation">
            From an End Customer, we collect information about the device and
            application an End Customer uses to access the content, such as End
            Customer’s IP address, operating system, browser user agent, and
            information related to End Customer’s use of the site including the
            length of time spent on the site and device and session identifiers
            that cannot be used to track users across different Customer Content
            or First-Party Content (defined below in Clause 6.6). IP addresses
            are only collected in standard raw web server logs for system/health
            monitoring purposes.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.3&nbsp;</li>
          <li className="li_style" role="presentation">
            Some Customer Content created with our Services may enable End
            Customer to:
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            view and interact with the same virtual objects at the same time in
            a shared physical space with other End Customer, as well as interact
            with and place virtual objects at real world locations. In order to
            provide this experience, we collect geospatial data and images from
            End Customer’s device camera and sensors when End Customer interact
            with this Customer Content.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            save data to a new or existing profile on the Portal. The processing
            of information related to your such profile shall be done in
            accordance with this Policy.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.4&nbsp;</li>
          <li className="li_style" role="presentation">
            We generally operates as a processor for Customer Content, meaning
            we process related personal information pursuant to our agreements
            with Enterprise (as defined in Terms). We may use the information
            that we collect to improve our Services. Any Enterprise that uses
            our Services to create Customer Content using our hosting services
            or self-hosted may be collecting additional personal information for
            their own products or services when you visit their site. We are not
            in control of additional data that may be collected by an Enterprise
            for this Customer Content. When accessing, viewing and/or
            interacting Customer Content, including saving data to End
            Customer’s profile (if any). End Customer should consider the
            privacy practices and policies of each Enterprise carefully.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.5&nbsp;</li>
          <li className="li_style" role="presentation">
            When First-Party Content or Customer Content is linked from or
            embedded or contains online advertisements, additional data may be
            collected by the platform of such advertisements. When viewing an
            advertisement, End Customer should consider the privacy practices
            and policies of each such advertising platform carefully.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.6&nbsp;</li>
          <li className="li_style" role="presentation">
            For purposes of this Privacy Policy, (a) “End Customer” means a
            person that accesses, views and/or interacts with Customer Content
            created by you that makes use of our Services, whether it be
            self-hosted or using our hosting services; and (b) “First-Party
            Content” means any application or website content created, managed
            and hosted by us, which includes our marketing site, marketing and
            support communications and website content developed internally by
            us using our Services.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">7. Location Services: </strong>
        </h3>
        <ul className="ul_style">
          <li>7.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal, its licensees and agents, may access, collect and
            analyse your usage of the Portal and other information related to
            your location on a regular basis through Bluetooth and Wi-Fi signals
            and other technologies and data for the performance of the services
            provided by the Portal and to help improve the design,
            functionality, performance, and content of the Portal. In order to
            collect geo-location information, the location settings must be
            enabled on your Device. Therefore, in some cases, the Portal may
            request that you enable the location settings.
          </li>
        </ul>
        <ul className="ul_style">
          <li>7.2&nbsp;</li>
          <li className="li_style" role="presentation">
            Except in cases where any specific services requested by you require
            or involve personal identification, the Portal collects location
            data anonymously and in a form that does not personally identify
            you. By using the Portal, you agree and consent to transmission,
            collection, maintenance, processing and use of your location data
            and queries to provide and improve such services of the Portal.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">8. Cookies </strong>
        </h3>
        <ul className="ul_style">
          <li>8.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Information collected by cookies (“Cookies”) and other technologies
            are treated as Non-Personal Information. However, to the extent that
            IP addresses or similar identifiers are considered Personal
            Information by local law, we treat any information linked to such
            identifiers as Personal Information. Similarly, to the extent that
            Non-Personal Information is combined with Personal Information, we
            will treat the combined information as Personal information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>8.2&nbsp;</li>
          <li className="li_style" role="presentation">
            You acknowledge and agree that third-party service providers may
            utilize Cookies or similar technologies to gather information about
            your usage patterns. This information is collected to optimize and
            provide advertisements based on your general browsing patterns.
          </li>
        </ul>
        <ul className="ul_style">
          <li>8.3&nbsp;</li>
          <li className="li_style" role="presentation">
            We neither have access to, nor do the Privacy Policy or Terms govern
            the use of Cookies or other tracking technologies that may be placed
            by third party service providers. These parties may permit you to
            opt out of tailored advertisement at any time, however, to the
            extent advertising technology is integrated into our services, you
            may still receive advertisements and related updates even if you
            choose to opt-out of tailored advertising. We assume no
            responsibility or liability whatsoever for the receipt or use of
            such tailored advertisements.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">
            9. Other Information the Portal collects:
          </strong>
        </h3>
        <ul className="ul_style">
          <li>9.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal also may collect other information about you in ways that
            the Portal describe to you or otherwise with your consent. You can
            choose not to provide us with certain types of information, but
            doing so may affect your ability to avail and/or use some services.
          </li>
        </ul>
        <ul className="ul_style">
          <li>9.2&nbsp;</li>
          <li className="li_style" role="presentation">
            By clicking “I Accept” button or by usage of the Portal you permit
            to enable certain functions of the Portal to find the location of
            your Device, modify or delete internal storage, read phone
            statistics and identity, mount and unmount file systems, contacts
            saved in your Device, conferencing logs and history etc.
          </li>
        </ul>
        <ul className="ul_style">
          <li>9.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The features of the Portal may allow you to post content such as
            text, software, scripts, graphics, photos, sounds, music, videos,
            audiovisual combinations, communications, interactive features,
            works of authorship of any kind, and information or other materials
            and/or information (which is covered under Customer Content). The
            ownership over the Customer Content created by you remains with you;
            however, by sharing Customer Content through the Portal, you agree
            to allow others to view and/or share your Customer Content in
            accordance with this Privacy Policy and Terms of Service of the
            Portal.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">
            10. Third Party Applications, Websites & Services:{" "}
          </strong>
        </h3>
        <ul className="ul_style">
          <li>10.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal may include links to other websites/applications or may
            display advertisements from third parties and other content that
            links to third party websites. Such websites/applications are
            governed by their respective privacy policies, which are out of the
            Portal’s control. Use of any information you provide while using a
            third party website or application through the Portal, is governed
            by the privacy policy of the operator of the website / application /
            operator you are using/ visiting. That policy may differ from that
            of the Portal. If you can't find the privacy policy of any of such
            websites /application via a link from the website's homepage, you
            should contact the relevant website /application operator directly
            for more information. We will not be responsible for notification of
            any change of any information on the Portal with respect to such
            third-party websites.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">11. Access, Correction and Deletion: </strong>
        </h3>
        <ul className="ul_style">
          <li>11.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The Portal strives hard to keep its records updated and accurate
            with your latest information. You shall be responsible to ensure
            that the information or data you provide from time to time is and
            shall be correct, current and updated and you have all the rights,
            permissions and consents to provide such information or data.
          </li>
        </ul>
        <ul className="ul_style">
          <li>11.2&nbsp;</li>
          <li className="li_style" role="presentation">
            You may note that deletion of certain information or withdrawal of
            consent may lead to cancellation of your access to the Portal or
            your access to certain features and services of the Portal.
            Additionally, we may not be able to process your request of
            correction, updating or deletion, in case the same is not supported
            by valid documents or data retention is required by the applicable
            law or law enforcement requests or under any judicial proceedings or
            it is extremely difficult to implement (such as requests related to
            backup copies or if a new system is required to process the request
            or change of technical design) or risks the privacy of other users.
          </li>
        </ul>
        <ul className="ul_style">
          <li>11.3&nbsp;</li>
          <li className="li_style" role="presentation">
            You acknowledge and agree that you may receive certain notifications
            relating to the Portal on your Device or on registered contact
            detail.
          </li>
        </ul>
        <ul className="ul_style">
          <li>11.4&nbsp;</li>
          <li className="li_style" role="presentation">
            You may request access, correction, or update, and deletion of your
            information provided to us by contacting us at{" "}
            <a href="mailto:grievance.officer@jio.com">
              grievance.officer@jio.com
            </a>
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">12. Grievance Officer: </strong>
        </h3>
        <ul className="ul_style">
          <li>12.1&nbsp;</li>
          <li className="li_style" role="presentation">
            In accordance with the Information Technology Act, 2000 and the
            rules made thereunder, the name and contact details of the grievance
            officer (“Grievance Officer”) are provided below:<br></br>
            <br></br>
            Grievance Officer: Amar Chikane <br></br>
            Contact Number: +91 9321975699 <br></br>
            Email Id: {grievanceEmail} <br></br>
            <br></br>
            It is further stated that the Grievance Officer shall acknowledge
            the complaint within 24 (Twenty-Four) hours from the date of receipt
            of your written grievance to the contact details mentioned under
            this Clause 12 and shall dispose of such complaint within a period
            of 15 (Fifteen) days from the date of its receipt.
          </li>
        </ul>
        <h3 role="presentation">
          <strong class="mr-l-20">13. Queries and Complaints: </strong>
        </h3>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            We are committed to protect your Personal Information collected and
            processed by us and look forward to your continued support for the
            same. In case of any feedback or concern regarding protection of
            your Personal Information, or any privacy-related feedback or
            concerns you may contact: Mr. Amar Chikane, Reliance Corporate IT
            Park, TC-22, Thane Belapur Road, Ghansoli, Navi Mumbai 400701 Email
            id: {grievanceEmail}
          </li>
        </ul>
      </div>
    </>
  );
};

export default HorizonPP;
